module.exports = __webpack_public_path__ + "static/media/time.feb617ca.svg";